import React from 'react';
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from '@material-ui/core';
import { RssFeed } from '@material-ui/icons';
import { Filters } from './../services/Filters';

const _filters = new Filters();


export const RssReaderItem = (props) => {
  const { 
    item: {
      header,
      start_ts,
      end_ts,
      link
    },
    itemFeed,
    onClick
  } = props;

  return (
    <ListItem
      divider
      button
      onClick={(e) => onClick(e, link)}
    >
      <ListItemIcon><RssFeed /></ListItemIcon>
      <ListItemText>
        {header}
        <Typography
          variant='caption'
        >
          {itemFeed ? <span>{itemFeed.FEED_TITLE}: </span> : null}
          {_filters.startEndDate(start_ts, end_ts)}
        </Typography>
      </ListItemText>
    </ListItem>
  )
}


// WEBPACK FOOTER //
// ./src/components/RssReaderItem.js